import React from "react";
import { Col, Row, Grid } from "react-bootstrap";
import { Link } from "react-router-dom";
import classnames from "classnames";

import linkedIn from "../../../../assets/images/linked-in-black.svg";
import whitePage from "../../../../assets/images/whitePage.svg";
import website from "../../../../assets/images/website.svg";
import styles from "./memberProfile.scss";
import ScrollToTopOnMount from "../../../../utils/scroll/ScrollToTopOnMount";
import { formatDate } from "../../../../utils/dates";
import matchStar from "../../../../assets/images/match-star.svg";

class MemberProfile extends React.Component {
  validURL(url) {
    //'http://' + _.get(memberData, 'links[0].url', '#')
    if (url) {
      if (url.search("http://") != -1) {
        return url;
      } else if (url.search("https://") != -1) {
        return url;
      } else {
        return `http://${url}`;
      }
    } else {
      return "#";
    }
  }

  render() {
    const { memberData, pitchData } = this.props;

    const skillsList =
      !_.isEmpty(memberData.skills) &&
      _.get(pitchData, "matched_on") &&
      memberData.skills.map((skill, index) => (
        <li key={index} className={styles.skillLI}>
          {skill.description.name}
          &nbsp;
          {pitchData.matched_on.some(
            match => match.name === skill.description.name
          ) ? (
            <img src={matchStar} className={styles.matchStar} />
          ) : (
            ""
          )}
        </li>
      ));

    const workHistoryList =
      !_.isEmpty(memberData.work_history) &&
      memberData.work_history.map((work, index) => (
        <div key={index}>
          <div>{index === 0 ? "" : <div className={styles.divider} />}</div>
          <h3>{_.get(work, "company.name")}</h3>
          <p className={styles.historyContent}>
            {work.role} | {work.years}
            {work.years > 1 ? " years" : " year"}
          </p>
        </div>
      ));

    const educationList =
      !_.isEmpty(memberData.education) &&
      memberData.education.map((education, index) => (
        <div key={index}>
          <div>{index === 0 ? "" : <div className={styles.divider} />}</div>
          <h3>{education.school.value}</h3>
          <p className={styles.historyContent}>{education.degree}</p>
        </div>
      ));

    return (
      <section className={styles.memberProfileContainer}>
        <ScrollToTopOnMount />
        <section className={styles.textFont}>
          <Grid className={styles.maxWidth}>
            <Row>
              <Col>
                <h1>{memberData.first_name + " " + memberData.last_name}</h1>
                <p>Member since {formatDate(memberData.created_at, "MMM Y")}</p>
                &nbsp;
              </Col>
            </Row>
            <Row>
              <div className={styles.divider} />
              <div className={styles.divider} />
            </Row>
            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Summary</h2>
            </div>
            {/* <Row>
              <div className={styles.whiteBackground}>
                <div className={styles.summarySection}>
                  {_.get(memberData, "profile.professional_summary")}
                </div>
                <div className={styles.divider} />
                <p className={styles.summarySubheader}>
                  {_.get(memberData, "profile.full_time_job")
                    ? "This member is available for a full-time, on-staff role."
                    : "This member is not available for a full-time, on-staff role."}
                </p>
              </div>
            </Row> */}
            <Row>
              <div className={styles.whiteBackground}>
                <div className={styles.summarySection}>
                  <h3 className={styles.summarySubheader}>City and State</h3>
                  {memberData.profile && memberData.profile.city}
                </div>
                <div className={styles.summarySection}>
                  <h3 className={styles.summarySubheader}>
                    Closest metro area
                  </h3>
                  {memberData.profile &&
                    memberData.profile.commute_city &&
                    memberData.profile.commute_city.value}
                </div>
                <div className={styles.summarySection}>
                  <h3 className={styles.summarySubheader}>
                    Professional Summary
                  </h3>
                  {_.get(memberData, "profile.professional_summary")}
                </div>
                {memberData && (
                  <div>
                    <div className={styles.divider} />
                    <p className={styles.summarySubheader}>
                      {_.get(memberData, "profile.full_time_job")
                        ? "This member is available for a full-time, on-staff role."
                        : "This member is not available for a full-time, on-staff role."}
                    </p>
                  </div>
                )}
              </div>
            </Row>
            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Additional Materials</h2>
            </div>
            <Row>
              <div className={styles.whiteBackground}>
                <div className={styles.linksFlex}>
                  <p>
                    <img src={whitePage} className={styles.logos} />
                    <span className={styles.materialsSpan}>Resumé </span>
                    {memberData &&
                    memberData.profile &&
                    memberData.profile.resume ? (
                      <span>
                        <Link
                          to="#"
                          onClick={this.props.downloadResume}
                          data-download="false"
                        >
                          Download
                        </Link>
                      </span>
                    ) : (
                      <small>- No resumé available -</small>
                    )}
                  </p>
                </div>
                <div className={styles.divider} />
                <div className={styles.linksFlex}>
                  <p>
                    <img src={linkedIn} className={styles.logos} />
                    <span className={styles.materialsSpan}>LinkedIn</span>
                    <a
                      target="_blank"
                      href={this.validURL(
                        _.get(memberData, "links[0].url", "#")
                      )}
                    >
                      {_.get(memberData, "links[0].url", "")}
                    </a>
                  </p>
                </div>
                <div className={styles.divider} />
                <div className={styles.linksFlex}>
                  <p>
                    <img src={website} className={styles.logos} />
                    <span className={styles.materialsSpan}>Website</span>
                    <a
                      target="_blank"
                      href={this.validURL(
                        _.get(memberData, "links[2].url", "#")
                      )}
                    >
                      {_.get(memberData, "links[2].url", "")}
                    </a>
                  </p>
                </div>
              </div>
            </Row>
            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Skills</h2>
            </div>
            <Row>
              <div className={styles.whiteBackground}>
                <ul>{skillsList}</ul>
              </div>
            </Row>
            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Work History</h2>
            </div>
            <Row>
              <div className={styles.whiteBackground}>{workHistoryList}</div>
            </Row>
            <div className={classnames(styles.editLink, "row")}>
              <h2 className={styles.header}>Education</h2>
            </div>
            <Row>
              <div className={styles.whiteBackground}>{educationList}</div>
            </Row>
          </Grid>
        </section>
      </section>
    );
  }
}

export default MemberProfile;



// WEBPACK FOOTER //
// ./src/routes/employer/memberProfile/components/memberProfile.js